type ImageTransformProps = {
    farNorthScaling?: number | null;
    children: React.ReactNode;
};

export const ImageTransform = ({ farNorthScaling, children }: ImageTransformProps) => {
    const scaleClass = farNorthScaling && farNorthScaling > 69 ? 'scale-[1.27]' : 'scale-[1.09]';

    return <div className={scaleClass}>{children}</div>;
};
